import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import { Link } from 'react-router-dom';
import ActionDropdownItems from './ActionDropdownItems';
import { Vendor } from 'api/user/vendor_requests';
import { PF } from 'helpers/utils';
import team15 from 'assets/img/team/avatar.webp';

const VendorItems = ({ vendor }: { vendor: Vendor }) => {
  return (
    <RevealDropdownTrigger className="hover-actions-trigger w-100">
      <figure
        className="border border-light-subtle d-flex justify-content-center align-items-center rounded-3 overflow-hidden position-relative mb-3 p-3 bg-body-tertiary"
        style={{ height: 180 }}
      >
        <img
          className="mw-100 h-100 object-fit-contain"
          src={vendor?.avatar ? PF + vendor.avatar : team15}
          alt={vendor?.fullName ?? vendor.fullName ?? 'Vendor Avatar'}
          style={{ maxHeight: '100%', width: 'auto' }}
        />

        {/* <RevealDropdown
                    className="hover-actions position-absolute top-0 end-0 m-2"
                    btnClassName="btn-icon btn-sm"
                >
                    <ActionDropdownItems />
                </RevealDropdown> */}
      </figure>

      <div className="text-start px-2">
        <Link to={`/vendordetails/${vendor._id}`} className="stretched-link">
          <h5 className="mb-1 text-truncate text-capitalize">
            {vendor.fullName ?? ''}
          </h5>
        </Link>
      </div>
    </RevealDropdownTrigger>
  );
};

export default VendorItems;
